export default "__VITE_ASSET__8ffdac58__"